import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import Request from "../../../helpers/request";
import * as url from "../../../helpers/url_helper";
import { toast } from "react-toastify";

interface DeleteFlowProps {
  isOpen: boolean;
  toggle: () => void;
  flowData: {
    _id?: string;
    name?: string;
    description?: string;
  } | null;
  onDeleteSuccess: () => void;
}

const DeleteFlow: React.FC<DeleteFlowProps> = ({
  isOpen,
  toggle,
  flowData,
  onDeleteSuccess,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!flowData?._id) {
      toast.error("Flow ID is required");
      return;
    }

    setLoading(true);
    try {
      const response = await Request.delete(
        `${url.BASE_URL}${url.DELETE_FLOW}`,
        { flowIds: flowData._id }
      );

      if (response.status === 200) {
        toast.success("Flow deleted successfully");
        onDeleteSuccess();
        toggle();
      }
    } catch (error: any) {
      console.error("Error deleting flow:", error);
      if (error?.response?.status === 401) {
        localStorage.removeItem("userInfo");
        localStorage.removeItem("selectedPremiseID");
        localStorage.removeItem("selectedUserID");
        localStorage.removeItem("selectedUserEmail");
        localStorage.removeItem("Authorization");
        localStorage.removeItem("permissions");
        window.location.reload();
      } else {
        toast.error(
          error?.response?.data?.message || "Failed to delete flow"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Delete Flow</ModalHeader>
      <ModalBody>
        <div className="text-center">
          <div className="mb-3">
            <box-icon name="trash" size="48px" color="#dc3545"></box-icon>
          </div>
          <h5>Are you sure you want to delete this flow?</h5>
          <p className="text-muted mb-0">
            This action cannot be undone. This will permanently delete the flow{" "}
            <strong>{flowData?.name}</strong> and remove all associated data.
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          className="btn btn-dark"
          size="sm"
          onClick={toggle}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          className="btn btn-dark"
          size="sm"
          onClick={handleDelete}
          disabled={loading}
        >
          {loading && (
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
          )}
          Delete Flow
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteFlow;
